var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from 'react-query';
import { useAxios, useToken } from 'shared/hooks';
export var useExperienceState = function () {
    var _a;
    var token = useToken();
    var axios = useAxios();
    return useQuery('experience-state', function () { return axios.get("/api/v1/experience_state"); }, {
        select: function (response) {
            var ehrFeatures = response.headers['x-enabled-features'];
            return __assign(__assign({}, response.data.data), { ehrFeatures: ehrFeatures });
        },
        enabled: !!((_a = token === null || token === void 0 ? void 0 : token.scopes) === null || _a === void 0 ? void 0 : _a.some(function (s) { return s.includes('compass'); })),
    });
};
